import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

const STORAGE_KEY = 'spinsafe_cookie_ack_v1';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const acked = localStorage.getItem(STORAGE_KEY);
      if (!acked) {
        // Delay slightly so it doesn't flash on first render
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const acknowledge = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-Hinweis"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] animate-fade-up"
    >
      <div className="bg-white border border-border shadow-2xl rounded-lg overflow-hidden">
        <div className="p-5">
          <div className="flex items-start gap-3 mb-3">
            <div className="flex-shrink-0 w-10 h-10 rounded-md bg-spin-green/10 flex items-center justify-center">
              <Cookie size={20} className="text-spin-green" />
            </div>
            <div>
              <h3 className="font-heading font-bold text-spin-dark text-base">
                Cookies auf Spinsafe
              </h3>
              <p className="text-sm text-spin-grey mt-1 leading-relaxed">
                Diese Website verwendet ausschließlich technisch notwendige Cookies, die für
                den ordnungsgemäßen Betrieb der Seite erforderlich sind. Es werden keine
                Tracking- oder Marketing-Cookies gesetzt. Mehr Informationen findest du in
                unserer{' '}
                <a href="/datenschutz" className="text-spin-green hover:underline font-semibold">
                  Datenschutzerklärung
                </a>
                .
              </p>
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={acknowledge}
              className="px-5 py-2 bg-spin-green text-white text-sm font-semibold rounded hover:bg-spin-green-dark transition-colors"
            >
              Verstanden
            </button>
          </div>
        </div>

        <button
          onClick={acknowledge}
          className="absolute top-2 right-2 p-1.5 text-spin-grey hover:text-spin-dark rounded transition-colors"
          aria-label="Schließen"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
